import { ProposalCardTypeLabelEnum } from "@repo/core/enums/proposals";
import {
  SelectedFinancialService,
  SelectedProduct,
  SelectedServicePoint
} from "@repo/core/types/proposals";

export const mockServicePoints: SelectedServicePoint[] = [
  {
    id: "1",
    name: "[PA - Ponto de Atendimento 1]",
    region: "UF - Município",
    address: "[Endereço do Ponto de Atendimento]"
  },
  {
    id: "2",
    name: "[PA - Ponto de Atendimento 2",
    region: "UF - Município",
    address: "[Endereço do Ponto de Atendimento]"
  }
];

export const mockFinancialServices: SelectedFinancialService[] = [
  {
    id: "1",
    title: "Clube de Vantagens Individual",
    subtitle: "R$ 39,90 mensais",
    items: [
      "Emergencia odontológicas 24h",
      "Telemedicina com atendimento 24h e consultas ilimitadas",
      "Sorteio de R$ 2.500 semanais",
      "Assistência Residencial, Farmácia, Medicamentos, Funeral."
    ]
  },
  {
    id: "2",
    title: "Clube de Vantagens Familiar",
    subtitle: "R$ 59,90 mensais",
    items: [
      "Emergencia odontológicas 24h",
      "Telemedicina com atendimento 24h e consultas ilimitadas",
      "Sorteio de R$ 2.500 semanais",
      "Assistência Residencial, Farmácia, Medicamentos, Funeral",
      "Emergencia odontológicas 24h",
      "Telemedicina com atendimento 24h e consultas ilimitadas",
      "Sorteio de R$ 2.500 semanais",
      "Assistência Residencial, Farmácia, Medicamentos, Funeral."
    ]
  },
  {
    id: "3",
    title: "Sem vantagens",
    subtitle: "R$ 0,00",
    items: []
  }
];

export const mockProducts: SelectedProduct[] = [
  {
    id: "1",
    name: "Wayup fidelidade",
    type: ProposalCardTypeLabelEnum.FIDELITY,
    number: "4321"
  },
  {
    id: "2",
    name: "Wayup fidelidade e crédito",
    type: ProposalCardTypeLabelEnum.FIDELITY_CREDIT,
    number: "9876"
  }
];
